import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import ThreeBackground from './ThreeBackground';
import CookieManager from './CookieManager';
import { FaCode, FaCloud, FaMobileAlt, FaPlug, FaChartBar, FaShieldAlt, FaEnvelope, FaWhatsapp, FaFacebook, FaYoutube, FaLinkedin, FaInstagram, FaDiscord, FaPhone, FaStar, FaFlag, FaGlobe, FaPlay, FaTrophy, FaCalendar, FaMapMarkerAlt, FaFileAlt, FaChevronLeft, FaChevronRight, FaBars, FaTimes } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';

const LandingPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentAwardIndex, setCurrentAwardIndex] = useState(0);
  const [youtubeVideoUrl, setYoutubeVideoUrl] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showCookieManager, setShowCookieManager] = useState(false);

  const socialMediaIcons = [
    {
      id: 1,
      socialMedia: "facebook",
      icon: FaFacebook,
      link: "https://www.facebook.com/learnfi",
    },
    {
      id: 2,
      socialMedia: "youtube",
      icon: FaYoutube,
      link: "https://www.youtube.com/channel/UCLTPNpuVET_FMlZwtgzl4uw",
    },
    {
      id: 3,
      socialMedia: "whatsapp",
      icon: FaWhatsapp,
      link: "https://api.whatsapp.com/send?phone=94761598225",
    },
    {
      id: 4,
      socialMedia: "linkedin",
      icon: FaLinkedin,
      link: "https://www.linkedin.com/showcase/learnfilk/",
    },
    {
      id: 5,
      socialMedia: "tiktok",
      icon: SiTiktok,
      link: "https://www.tiktok.com/@learnfi.lk?_t=8ngkVxNgPLM&_r=1",
    },
    {
      id: 6,
      socialMedia: "instagram",
      icon: FaInstagram,
      link: "https://www.instagram.com/learnfi.lk?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    },
    {
      id: 7,
      socialMedia: "discord",
      icon: FaDiscord,
      link: "https://discord.gg/MTScrsPQ7s",
    },
  ];

  const awardsData = [
    {
      "id": "award-001", 
      "image": "https://resource.learnfi.lk/learnfi/awards/youtube thumbnail-best-web-gold.webp",
      "title": "Gold Winner – Best Education Website",
      "description": "LearnFi.lk was honored with the prestigious Gold Award for Best Education Website at BestWeb.LK 2025 – Sri Lanka's Premier Web Design Competition.",
      "organization": "BestWeb.LK 2025",
      "backgroundRemoveAwardPngImage": "https://resource.learnfi.lk/learnfi/awards/Bestweb-2025-logo/gold-winner.webp",
      "videoLink": "https://www.youtube.com/watch?v=u1x8PVBDbL4",
      "date": "2025-08-27",
      "location": "Monarch Imperial, Colombo, Sri Lanka",
      "awardType": "National",
      "certificateLink": null,
      "officialWebsite": "https://bestweb.lk/past-winners/3",
      "altText": "LearnFi.lk won the Gold Award in the Best Education Website category at BestWeb.LK 2025.",
      "sortOrder": 1,
      "highlight": true
    },
    {
      "id": "award-002", 
      "image": "https://resource.learnfi.lk/learnfi/awards/youtube thumbnail-bestweb-2025-ui.webp",
      "title": "Best Mobile User Experience Website",
      "description": "LearnFi.lk was recognized for delivering outstanding mobile usability and design, winning the Best Mobile User Experience Website Award at BestWeb.LK 2025.",
      "organization": "BestWeb.LK 2025",
      "backgroundRemoveAwardPngImage": "https://resource.learnfi.lk/learnfi/awards/Bestweb-2025-logo/user-experience-web.webp",
      "videoLink": "https://www.youtube.com/watch?v=u1x8PVBDbL4",
      "date": "2025-08-27",
      "location": "Monarch Imperial, Colombo, Sri Lanka",
      "awardType": "National",
      "certificateLink": null,
      "officialWebsite": "https://bestweb.lk/past-winners/3",
      "altText": "LearnFi.lk won the Best Mobile User Experience Website Award at BestWeb.LK 2025.",
      "sortOrder": 2,
      "highlight": true
    },
    {
      "id": "award-003", 
      "image": "https://resource.learnfi.lk/learnfi/awards/iconic-awards-thumbnail.webp",
      "title": "Educational Technology Provider of the Year",
      "description": "LearnFi.lk was recognized as the Best Education Website at BestWeb.LK 2025 for its innovation, design, and impact on digital learning.",
      "organization": "Global Business Excellence Awards 2025",
      "backgroundRemoveAwardPngImage": "https://resource.learnfi.lk/learnfi/awards/global-business-excellence-awards-2025-removebg.png",
      "videoLink": "https://youtu.be/CANfPV9x7Ck?si=V876qzLWbBacT47V",
      "date": "2025-08-10",
      "location": "BMICH, Colombo, Sri Lanka",
      "awardType": "Global",
      "certificateLink": null,
      "officialWebsite": "https://gbeaward.com",
      "altText": "LEARNFI (Pvt) Ltd was honored with the Educational Technology Provider of the Year 2025 Award.",
      "sortOrder": 3,
      "highlight": true
    },
    {
      "id": "award-004",
      "image": "https://resource.learnfi.lk/learnfi/awards/Global-Business-Excellence-Awards-2025.webp",
      "title": "Digital Learning Excellence Award",
      "description": "LearnFi.lk was recognized as the Best Education Website at BestWeb.LK 2025 for its innovation, design, and impact on digital learning.",
      "organization": "Iconic awards 2025",
      "backgroundRemoveAwardPngImage": "https://resource.learnfi.lk/learnfi/awards/global-business-excellence-awards-2025-removebg.png",
      "videoLink": "https://youtu.be/yauNdrFNFGs?si=X7wwsBiANbyLl-YK",
      "date": "2025-08-10",
      "location": "Monarch Imperial, Colombo, Sri Lanka",
      "awardType": "National",
      "certificateLink": null,
      "officialWebsite": "https://iconicawards.lk",
      "altText": "LEARNFI (Pvt) Ltd received the Digital Learning Excellence Award – Sri Lanka, 2025.",
      "sortOrder": 4,
      "highlight": false
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  // Auto-advance carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAwardIndex((prev) => (prev === awardsData.length - 1 ? 0 : prev + 1));
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false); // Close mobile menu when link is clicked
  };

  const openCalendly = () => {
    const calendlyUrl = 'https://calendly.com/learnfi-business-support/30min';
    
    // Check if Calendly widget is loaded
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: calendlyUrl
      });
    } else {
      // Fallback: open in new window if Calendly widget not loaded
      window.open(calendlyUrl, '_blank', 'width=700,height=600');
    }
  };

  const openYouTubePopup = (videoUrl) => {
    // Convert YouTube URL to embed format
    let embedUrl = '';
    
    if (videoUrl.includes('youtu.be/')) {
      // Short URL format: https://youtu.be/VIDEO_ID
      const videoId = videoUrl.split('youtu.be/')[1].split('?')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    } else if (videoUrl.includes('youtube.com/watch?v=')) {
      // Long URL format: https://www.youtube.com/watch?v=VIDEO_ID
      const videoId = videoUrl.split('v=')[1].split('&')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    } else if (videoUrl.includes('youtube.com/embed/')) {
      // Already embed format
      embedUrl = videoUrl.includes('?') ? `${videoUrl}&autoplay=1` : `${videoUrl}?autoplay=1`;
    } else {
      // Fallback: open in new tab
      window.open(videoUrl, '_blank');
      return;
    }

    setYoutubeVideoUrl(embedUrl);
  };

  const closeYouTubePopup = () => {
    setYoutubeVideoUrl(null);
  };

  return (
    <div className="landing-page">
      {/* Navigation */}
      <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="nav-container">
          <div className="nav-logo">
            <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }} className="logo-link">
              <img 
                src="/images/logo/full.webp" 
                alt="BizFi Logo" 
                className="nav-logo-image"
              />
            </a>
          </div>
          <button 
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
          <div className={`nav-menu ${isMobileMenuOpen ? 'nav-menu-open' : ''}`}>
            <a href="#home" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a>
            <a href="#services" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a>
            <a href="#awards" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('awards'); }}>Awards</a>
            <a href="#about" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About</a>
            <a href="#contact" className="nav-link" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact Us</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero-section">
        <div className="hero-background">
          <ThreeBackground />
          <div className="hero-gradient-overlay"></div>
          <div className="hero-pattern"></div>
          <div className="hero-wavy-pattern"></div>
        </div>
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Where Technology Meets Real Business Results
            </h1>
            <p className="hero-description">
            Your dedicated tech partner for custom software, automation, and enterprise-grade digital solutions.
            </p>
            <div className="hero-buttons">
              <button className="btn-hero-cta" onClick={openCalendly}>
                <FaPhone className="btn-icon" />
                Book a call
              </button>
              <a 
                href="https://api.whatsapp.com/send?phone=94761598225" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-hero-whatsapp"
              >
                <FaWhatsapp className="btn-icon" />
                WhatsApp Us
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Services</h2>
            <p className="section-subtitle">Comprehensive software solutions tailored to your business needs</p>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon"><FaCode /></div>
              <h3 className="service-title">Custom Software Development</h3>
              <p className="service-description">
                Build scalable, robust applications tailored to your unique business requirements 
                using modern technologies and best practices.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon"><FaCloud /></div>
              <h3 className="service-title">Cloud Solutions & DevOps</h3>
              <p className="service-description">
                Optimize your infrastructure with cloud migration, CI/CD pipelines, and automated 
                deployment strategies for maximum efficiency.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon"><FaMobileAlt /></div>
              <h3 className="service-title">SaaS Platform Development</h3>
              <p className="service-description">
                Create powerful SaaS platforms with subscription management, multi-tenancy, 
                and enterprise-grade security features.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon"><FaPlug /></div>
              <h3 className="service-title">API Development & Integration</h3>
              <p className="service-description">
                Design and implement RESTful APIs, microservices architecture, and seamless 
                third-party integrations for your ecosystem.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon"><FaChartBar /></div>
              <h3 className="service-title">Data Analytics & BI</h3>
              <p className="service-description">
                Transform your data into actionable insights with advanced analytics, 
                reporting dashboards, and business intelligence solutions.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon"><FaShieldAlt /></div>
              <h3 className="service-title">Security & Compliance</h3>
              <p className="service-description">
                Ensure your applications meet industry standards with security audits, 
                compliance frameworks, and robust authentication systems.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about-section">
        <div className="container">
          <div className="about-content-wrapper">
            <div className="about-text-content">
              <h2 className="section-title">About Learnfi Business</h2>
              <p className="about-text">
                Learnfi Business (BizFi) is the software development and digital solutions division of Learnfi (Pvt) Ltd. 
                Built on the same innovation and reliability that powers the Learnfi.lk EdTech platform, BizFi focuses 
                on delivering smart, scalable, and business-ready technology solutions for modern organizations.
              </p>
              <p className="about-text">
                We specialize in crafting custom digital products—from business management systems and web applications 
                to cloud integrations, automations, and enterprise tools. Each solution is engineered with precision, 
                security, and future-readiness, ensuring that businesses can operate more efficiently and grow faster 
                in a digital-first world.
              </p>
              <p className="about-text">
                Whether you're a startup, SME, or enterprise, BizFi transforms your ideas into powerful, fully functional 
                software, backed by strong engineering practices and a commitment to long-term quality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Awards Section */}
      <section id="awards" className="awards-section">
        <div className="container">
          <div className="awards-header">
            <h2 className="awards-main-title">
              Proudly Winning <span className="awards-highlight">National & Global Awards</span>
            </h2>
            <p className="awards-subtitle">
              Recognized worldwide for innovation, excellence, and transformative impact in digital education technology.
            </p>
          </div>

          {/* Awards Summary */}
          <div className="awards-summary">
            <div className="summary-item">
              <div className="summary-number">{awardsData.length}</div>
              <div className="summary-label">TOTAL AWARDS</div>
            </div>
            <div className="summary-item">
              <div className="summary-number">{awardsData.filter(a => a.awardType === 'National').length}</div>
              <div className="summary-label">NATIONAL</div>
            </div>
            <div className="summary-item">
              <div className="summary-number">{awardsData.filter(a => a.awardType === 'Global').length}</div>
              <div className="summary-label">GLOBAL</div>
            </div>
          </div>

          {/* Awards Carousel */}
          <div className="awards-carousel-wrapper">
            <button 
              className="carousel-arrow carousel-arrow-left"
              onClick={() => setCurrentAwardIndex((prev) => (prev === 0 ? awardsData.length - 1 : prev - 1))}
              aria-label="Previous award"
            >
              <FaChevronLeft />
            </button>

            <div className="awards-carousel">
              {awardsData.map((award, index) => (
                <div 
                  key={award.id} 
                  className={`award-carousel-card ${index === currentAwardIndex ? 'active' : ''}`}
                >
                  <div className="award-card-left">
                    <div className="award-image-tags">
                      {award.highlight && (
                        <span className="award-tag featured-tag">
                          <FaStar className="tag-icon" /> Featured Award
                        </span>
                      )}
                      <span className={`award-tag type-tag ${award.awardType.toLowerCase()}`}>
                        {award.awardType === 'National' ? <FaFlag className="tag-icon" /> : <FaGlobe className="tag-icon" />} {award.awardType}
                      </span>
                    </div>
                    <div className="award-image-container">
                      <img 
                        src={award.image} 
                        alt={award.altText}
                        className="award-carousel-image"
                        loading="lazy"
                      />
                      {award.videoLink && (
                        <div 
                          className="video-play-overlay"
                          onClick={() => openYouTubePopup(award.videoLink)}
                        >
                          <FaPlay className="play-icon" />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="award-card-right">
                    <div className="award-org-badge">
                      <FaTrophy className="org-icon" />
                      <span className="org-name">{award.organization}</span>
                    </div>
                    <h3 className="award-carousel-title">{award.title}</h3>
                    <p className="award-carousel-description">{award.description}</p>
                    <div className="award-carousel-meta">
                      <div className="meta-item">
                        <FaCalendar className="meta-icon" />
                        <span>{new Date(award.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                      </div>
                      <div className="meta-item">
                        <FaMapMarkerAlt className="meta-icon" />
                        <span>{award.location}</span>
                      </div>
                    </div>
                    <div className="award-carousel-buttons">
                      {award.videoLink && (
                        <a 
                          href={award.videoLink} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="btn-watch-video"
                        >
                          <FaPlay className="btn-icon" />
                          Watch Video
                        </a>
                      )}
                      {award.officialWebsite && (
                        <a 
                          href={award.officialWebsite} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="btn-learn-more"
                        >
                          <FaFileAlt className="btn-icon" />
                          Learn More
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button 
              className="carousel-arrow carousel-arrow-right"
              onClick={() => setCurrentAwardIndex((prev) => (prev === awardsData.length - 1 ? 0 : prev + 1))}
              aria-label="Next award"
            >
              <FaChevronRight />
            </button>
          </div>

          {/* Carousel Dots */}
          <div className="carousel-dots">
            {awardsData.map((_, index) => (
              <button
                key={index}
                className={`carousel-dot ${index === currentAwardIndex ? 'active' : ''}`}
                onClick={() => setCurrentAwardIndex(index)}
                aria-label={`Go to award ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Parent Company Section */}
      <section id="parent-company" className="parent-company-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About Our Parent Company</h2>
            <p className="section-subtitle">Learnfi (Pvt) Ltd</p>
          </div>
          <div className="parent-company-content">
            <div className="parent-company-text">
              <p className="parent-company-description">
                <strong>Learnfi (Pvt) Ltd</strong> — widely recognized through its flagship platform <a href="https://learnfi.lk" target="_blank" rel="noopener noreferrer" className="learnfi-link">LearnFi.lk</a> — is a leading EdTech company in Sri Lanka dedicated to making high-quality, future-ready education accessible to everyone. As an innovative online learning platform, LearnFi offers a wide range of expert-led courses in technology, business, personal development, and more. Learners can access both free and premium programs from anywhere, supported by an intuitive interface and flexible learning model that empowers individuals to grow at their own pace.
              </p>
              <p className="parent-company-description">
                Beyond learner-focused experiences, LearnFi also builds opportunities for instructors, enabling passionate educators to share their knowledge and develop meaningful careers through a global teaching community.
              </p>
              <p className="parent-company-description">
                Founded in 2025, LearnFi has rapidly become a trusted name in digital education—recognized as a finalist at BestWeb.LK 2025, awarded Gold for Best Education Website, and honored with the Global Business Excellence Award for its outstanding impact in the EdTech sector.
              </p>
              <p className="parent-company-description">
                As the parent company of BizFi, LearnFi continues its mission to uplift lives through innovation, technology, and accessible learning.
              </p>
              <div className="parent-company-cta">
                <a 
                  href="https://learnfi.lk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn-learnfi-visit"
                >
                  Visit LearnFi.lk
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Contact Us</h2>
            <p className="section-subtitle">Ready to transform your business? Let's discuss your project</p>
          </div>
          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon"><FaEnvelope /></div>
                <div>
                  <h4>Business Email</h4>
                  <p>business@learnfi.lk</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon"><FaEnvelope /></div>
                <div>
                  <h4>Support Email</h4>
                  <p>support@learnfi.lk</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon"><FaWhatsapp /></div>
                <div>
                  <h4>WhatsApp</h4>
                  <p>+94 76 159 8225</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner-section">
        <div className="container">
          <div className="cta-banner">
            <h2 className="cta-banner-title">
              Kickstart with a Free<br />
              Tech Strategy Session!
            </h2>
            <button className="cta-banner-button" onClick={openCalendly}>
              Book a call <span className="cta-arrow">&gt;</span>
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img 
                src="/images/logo/bizfi-logo-with-text.webp" 
                alt="BizFi Logo" 
                className="footer-logo-image"
              />
            </div>
            <p className="footer-text">
              © 2025{' '}
              <a 
                href="https://learnfi.lk" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-company-link"
              >
                LEARNFI (PVT) LTD
              </a>{' '}
              All rights reserved.
            </p>
            <div className="footer-social">
              {socialMediaIcons.map((social) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={social.id}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-social-icon"
                    aria-label={social.socialMedia}
                  >
                    <IconComponent />
                  </a>
                );
              })}
            </div>
            <div className="footer-links">
              <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
              <Link to="/terms-of-service" className="footer-link">Terms of Service</Link>
              <Link to="/cookie-policy" className="footer-link">Cookie Policy</Link>
              <button 
                className="footer-link footer-link-button" 
                onClick={() => setShowCookieManager(true)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
              >
                Cookie Settings
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* YouTube Video Modal */}
      {youtubeVideoUrl && (
        <div className="youtube-modal-overlay" onClick={closeYouTubePopup}>
          <div className="youtube-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="youtube-modal-close" onClick={closeYouTubePopup}>
              ×
            </button>
            <iframe
              src={youtubeVideoUrl}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="youtube-modal-iframe"
            ></iframe>
          </div>
        </div>
      )}

      {/* Cookie Manager */}
      {showCookieManager && (
        <CookieManager onClose={() => setShowCookieManager(false)} />
      )}
    </div>
  );
};

export default LandingPage;

